import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EmailTemplateModel } from 'common/models/page-models/Email-Template/email-template-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { EmailTemplateFormWidgetService } from 'common/widget/email-template/email-template-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateFormResolver extends FormResolverService<EmailTemplateModel> {
    constructor(
        protected fs: EmailTemplateFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel) {
        dataModel['keyword']='';
        return dataModel;
    }

}
